interface ProfileOverviewSectionProps {
  profileError?: string;
  balanceError?: string;
}

/** Renders error banners for the profile overview body area. */
export function ProfileOverviewSection({ profileError, balanceError }: ProfileOverviewSectionProps) {
  if (!profileError && !balanceError) return null;
  return (
    <p className="mb-3 text-xs text-muted-foreground">
      Часть данных профиля недоступна. Показаны fallback-значения.
    </p>
  );
}
